module.exports = __webpack_public_path__ + "img/404-image.ac9ef1e.svg";